import { useState } from 'react';
import type { FAQData } from '@/content/types';

export default function FAQ(props: FAQData) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="section-padding">
      <div className="container" style={{ maxWidth: 960 }}>
        {props.title && (
          <h2 className="h-feature" style={{ marginBottom: 32 }}>{props.title}</h2>
        )}
        {props.items.map((item, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              style={{
                marginBottom: 12,
                borderRadius: 24,
                overflow: 'hidden',
              }}
            >
              <div
                onClick={() => setOpen(isOpen ? null : i)}
                style={{
                  padding: '14px 20px',
                  background: 'var(--color-clay)',
                  color: '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                <span style={{ fontSize: 18, fontWeight: 700, flexShrink: 0 }}>{isOpen ? '−' : '+'}</span>
                <span>{item.q}</span>
              </div>
              {isOpen && (
                <div
                  style={{
                    padding: '14px 20px 18px 50px',
                    background: 'var(--color-cream)',
                    color: 'var(--color-ink)',
                    fontSize: 14,
                    lineHeight: 1.6,
                  }}
                >
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
